import {SnackbarProvider} from "notistack";
import IndexMain from "./routes/IndexMain";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import DataStore from "../src/store/DataStore";
import SessionStore from '../src/store/SessionStore'
import ControlStore from '../src/store/ControlStore'
import {Provider} from 'mobx-react';
import esMessages from "devextreme/localization/messages/es.json";
import {loadMessages, locale} from "devextreme/localization";

loadMessages(esMessages);
locale(navigator.language);

function App() {
    return (
        <Provider DataStore={DataStore} SessionStore={SessionStore} ControlStore={ControlStore}>
            <SnackbarProvider maxSnack={5}>
                <IndexMain />
            </SnackbarProvider>
        </Provider>
    );
}

export default App;
